import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-no-record-found',
  imports: [MatCardModule, MatIcon],
  templateUrl: './no-record-found.component.html',
  styleUrl: './no-record-found.component.scss'
})
export class NoRecordFoundComponent {

}
